import React, { ComponentType } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LendingDataTable from './LendingDataTable';

const Router: ComponentType = () => {
  return (
    <Switch>
      <Route exact path={'/lending'}>
        <Redirect to="/lending/list" />
      </Route>

      <Route path="/lending/list">
        <LendingDataTable />
      </Route>
    </Switch>
  );
};

export default Router;
